/**
 * The upload proxy derives the destination cohort from the current server-side
 * profile, then returns it in every successful receipt. The client must use
 * this value for polling rather than reconstructing a company cohort from a
 * potentially stale JWT claim.
 */
export function uploadReceiptCohortId(data: unknown): string {
  const cohortId =
    data && typeof data === "object" && "cohort_id" in data
      ? (data as { cohort_id?: unknown }).cohort_id
      : undefined;
  if (typeof cohortId !== "string" || !cohortId.trim()) {
    throw new Error("Upload service response is missing its destination cohort.");
  }
  return cohortId;
}
